//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'PaginationComponent',
  props: {
    currentPage: {
      type: Number,
      default: 0
    },
    totalItems: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 0
    },
    baseLink: {
      type: String,
      default: ''
    },
    query: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      separator: '...'
    }
  },
  computed: {
    delta () {
      if (this.$store.state.breakpoint.screen.widthMinCalc >= 768) {
        return 2
      }
      return 1
    },
    amountOfPages () {
      return Math.ceil(this.totalItems / this.perPage)
    },
    params () {
      if (this.query) {
        return this.query
      }
      let params = ''
      let i = 0
      for (const [key, value] of Object.entries(this.$route.query)) {
        if (key !== 'page') {
          params += (i > 0 ? '&' : '') + key + '=' + value
          i++
        }
      }
      return params
    },
    pageNumbers () {
      const current = this.currentPage
      const last = this.amountOfPages
      const delta = this.delta
      const left = current - delta
      const right = current + delta + 1
      const range = []
      const rangeWithDots = []
      let l

      for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
          range.push(i)
        }
      }

      for (const i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1)
          } else if (i - l !== 1) {
            rangeWithDots.push(this.separator)
          }
        }
        rangeWithDots.push(i)
        l = i
      }

      return rangeWithDots
    }
  },
  methods: {
    selectPage (pageNumber) {
      this.$nuxt.$emit('setPage', pageNumber)
      this.$emit('setPage', pageNumber)
    },

    previous () {
      this.selectPage(this.currentPage - 1)
    },

    next () {
      this.selectPage(this.currentPage + 1)
    }
  }
}
